import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import SessionStyles from '../../styles/Session'

const NotAllowed = (props) => {
  const { classes } = props

  return (
    <div className={classes.session}>
      <div className={classes.content}>
        <Typography className={classes.title}>405</Typography>
        <Typography className={classes.subtitle}>Not Allowed!</Typography>
        <Typography variant="caption">Sorry, but the page you have no access to this content.</Typography>
      </div>
    </div>
  );
}

NotAllowed.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(SessionStyles)(NotAllowed)


// WEBPACK FOOTER //
// ./src/components/Errors/NotAllowed.js